import Carousel from '../modules/Carousel';
import CookieBar from "../modules/CookieBar";
import ElasticSearch from "../modules/ElasticSearch";
import Nav from "../modules/Nav";
import QuickAdd from "../modules/QuickAddCart";
import QuickAddList from "../modules/QuickAddList";
import SubmitAdd from "../modules/SubmitAddCart";
import goTop from "../modules/goTop";

export default {
  init() {
    Nav();
    SubmitAdd();
    QuickAdd();
    QuickAddList();
    Carousel();
  },
  finalize() {
    goTop();
    CookieBar();
    ElasticSearch();
  },
};



// WEBPACK FOOTER //
// ./assets/src/js/routes/common.js